module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8ESOm"))).then(() => module.bundle.root('37nVf'));